import axios from 'axios'
import config from '@/config'
import { sha256 } from 'js-sha256';
import base64url from "base64url";

const API_URL = config.API_URL

export default {
  state: {
    userInfo_data: [],
  },
  mutations: {
    loginUserData: (state, response) => state.userInfo_data = response,
  },
  actions: {
    async changeUserData(ctx, loginData ){
      const key = localStorage.getItem("weltumKey")
      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      await axios.post(
        `${API_URL}/api/rest/receipt/kabinet_in_ident`,

        loginData,
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Hmac': Hmac,
          'X-Time': Time, 
          }
        },
        
      ).then((response) => {
        localStorage.setItem('weltumTimeAuth', Date.now())
        ctx.commit('loginUserData', response.data)
      })

    }
  },
  getters:{
    userInfo_data: s => s.userInfo_data,
  },
}